import React, { useState } from 'react';

const ExportModal = ({ isOpen, onClose, onExport }) => {
    const [format, setFormat] = useState('png');
    const [quality, setQuality] = useState('300'); // '300', '600', '1200'

    if (!isOpen) return null;

    const handleExport = () => {
        onExport(format, parseInt(quality));
        onClose();
    };

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in duration-200">
                <div className="p-5 border-b border-slate-100 flex justify-between items-center bg-slate-50">
                    <h3 className="font-bold text-lg text-slate-800">Exportar Diseño</h3>
                    <button onClick={onClose} className="text-slate-400 hover:text-slate-600 transition-colors">
                        <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                <div className="p-6 space-y-6">
                    {/* Formato */}
                    <div>
                        <label className="block text-sm font-medium text-slate-700 mb-2">Formato de Imagen</label>
                        <div className="grid grid-cols-2 gap-4">
                            <button
                                onClick={() => setFormat('png')}
                                className={`px-4 py-3 rounded-lg border flex items-center justify-center space-x-2 transition-all ${format === 'png'
                                        ? 'bg-blue-50 border-blue-500 text-blue-700 ring-1 ring-blue-500'
                                        : 'bg-white border-slate-200 text-slate-600 hover:bg-slate-50'
                                    }`}
                            >
                                <span className="font-bold">PNG</span>
                                <span className="text-xs opacity-75">(Transparencia)</span>
                            </button>
                            <button
                                onClick={() => setFormat('jpeg')}
                                className={`px-4 py-3 rounded-lg border flex items-center justify-center space-x-2 transition-all ${format === 'jpeg'
                                        ? 'bg-blue-50 border-blue-500 text-blue-700 ring-1 ring-blue-500'
                                        : 'bg-white border-slate-200 text-slate-600 hover:bg-slate-50'
                                    }`}
                            >
                                <span className="font-bold">JPG</span>
                                <span className="text-xs opacity-75">(Comprimido)</span>
                            </button>
                        </div>
                    </div>

                    {/* Calidad / DPI */}
                    <div>
                        <label className="block text-sm font-medium text-slate-700 mb-2">Calidad (DPI/PPP)</label>
                        <div className="space-y-3">
                            {[
                                { value: '300', label: '300 DPI', desc: 'Impresión Estándar' },
                                { value: '600', label: '600 DPI', desc: 'Alta Calidad' },
                                { value: '1200', label: '1200 DPI', desc: 'Ultra Alta Definición' }
                            ].map((opt) => (
                                <button
                                    key={opt.value}
                                    onClick={() => setQuality(opt.value)}
                                    className={`w-full px-4 py-3 rounded-lg border text-left flex justify-between items-center transition-all ${quality === opt.value
                                            ? 'bg-blue-50 border-blue-500 text-blue-700 ring-1 ring-blue-500'
                                            : 'bg-white border-slate-200 text-slate-600 hover:bg-slate-50'
                                        }`}
                                >
                                    <span className="font-medium">{opt.label}</span>
                                    <span className="text-sm opacity-75">{opt.desc}</span>
                                </button>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="p-5 border-t border-slate-100 flex justify-end space-x-3 bg-slate-50">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 rounded-lg text-slate-600 hover:bg-slate-200 font-medium transition-colors"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={handleExport}
                        className="px-6 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-bold shadow-md transition-all active:scale-95 flex items-center space-x-2"
                    >
                        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                        </svg>
                        <span>Exportar</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ExportModal;
